<template>
    <div class="flex justify-between items-center my-3">
        <h3 class="text-xl leading-6 font-large dark:text-white flex item-center">
            Gerentes de Conta <store-modal @fetch="fetch"/>
        </h3>
        
        <button
            class="btn-primary-sm"
            :disabled="loading || exportLoading"
            @click.prevent="exportManagers"
        >
            <ArrowDownTrayIcon
                class="mr-1.5 h-5 w-5 flex-shrink-0 text-white"
                aria-hidden="true"
            />
            {{ exportLoading ? 'Exportando...' : 'Exportar' }}
        </button>
    </div>

    <ticto-loading v-if="loading" />
    <div class="not-prose relative rounded-xl rounded">
        <empty-state v-if="!loading && !managers.length"/>
        <ul role="list" class="divide-y dark:divide-slate-700">
            <manager
                v-if="!loading"
                v-for="(manager, index) in managers"
                :manager="manager"
                :class="{
                    'rounded-t-lg': index === 0,
                    'rounded-b-lg': index === managers.length - 1
                }"
                @fetch="fetch"
            />
        </ul>
    </div>
</template>

<script>
    import { ArrowDownTrayIcon } from "@heroicons/vue/24/outline";
    import { useToast } from "vue-toastification";
    import TictoLoading from "../../components/layouts/TictoLoading.vue";
    import UsersSelect from "../../components/forms/UsersSelect.vue";
    import VueSelect from "../../components/forms/VueSelect.vue";
    import Manager from "../../components/manager/Manager.vue";
    import StoreModal from "../../components/manager/modals/StoreModal.vue";
    import EmptyState from "../../components/layouts/EmptyState.vue";
    
    export default {
        components: {
            EmptyState, 
            StoreModal, 
            Manager, 
            VueSelect, 
            UsersSelect, 
            TictoLoading,
            ArrowDownTrayIcon
        },
        data() {
            return {
                loading: false,
                exportLoading: false,
                managers: [],
            }
        },

        setup() {
            const toast = useToast();
            return { toast };
        },

        mounted() {
            this.fetch();
        },

        methods: {
            exportManagers() {
                this.exportLoading = true;
                axios
                    .get("/api/account-manager/export")
                    .then(({ data }) => {
                        // Abrir URL para download
                        window.open(data.download_url, '_blank');
                        this.toast.success(
                            "Download iniciado com sucesso!"
                        );
                        this.exportLoading = false;
                    })
                    .catch((error) => {
                        this.toast.error(
                            "Erro ao gerar exportação. Tente novamente."
                        );
                        this.exportLoading = false;
                    });
            },
            fetch() {
                this.loading = true;
                axios.get('/api/account-manager/').then(({data}) => {
                    this.managers = data;
                    this.loading = false;
                })
            }
        }
    }
</script>
